import React, { useState } from 'react';

const CancelSaleModal = ({ isOpen, onClose, onConfirm, loading = false }) => {
  const [reason, setReason] = useState('');

  if (!isOpen) return null;

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm(reason);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <h3>Cancel Sale</h3>
        </div>
        
        <div className="modal-content">
          <p>Please provide a reason for cancelling this sale.</p>
          
          <div className="form-group">
            <label>Cancellation Reason</label>
            <textarea
              className="form-textarea"
              placeholder="Enter reason..."
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              rows={4}
            />
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose}>
            Close
          </button>
          <button 
            className="btn-danger" 
            onClick={handleConfirm}
            disabled={loading}
          >
            {loading ? 'Cancelling...' : 'Cancel Sale'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelSaleModal;